import type { SkillId } from './rules/index.js';

/**
 * Canonical camelCase SkillId → snake_case sheet proficiency key
 * (e.g. `animalHandling` → `animal_handling_prof`).
 *
 * Single source of truth — the HUD read adapter, the write side, and the
 * character builder all map skills here instead of re-typing the 18-entry table
 * (which previously existed in 3 places and was a drift source). Keep in step
 * with the `*_prof` skill fields in template.ts / sheet-values-schema.ts.
 */
export const SKILL_KEY_MAP: Record<SkillId, string> = {
  acrobatics: 'acrobatics_prof',
  animalHandling: 'animal_handling_prof',
  arcana: 'arcana_prof',
  athletics: 'athletics_prof',
  deception: 'deception_prof',
  history: 'history_prof',
  insight: 'insight_prof',
  intimidation: 'intimidation_prof',
  investigation: 'investigation_prof',
  medicine: 'medicine_prof',
  nature: 'nature_prof',
  perception: 'perception_prof',
  performance: 'performance_prof',
  persuasion: 'persuasion_prof',
  religion: 'religion_prof',
  sleightOfHand: 'sleight_of_hand_prof',
  stealth: 'stealth_prof',
  survival: 'survival_prof',
};
